import axios from "axios";
import "../components/Error";
import { getEnv } from "../components/helpers/Config";
import i18next from "i18next";

// "homepage": "https://recallrtr-test.azurewebsites.net/acmeunitedotc2",
export const Axios = {
  email,
  addressValidation,
  shippingLabel,
};
function email(data, instance, refund) {
  const tSubject = i18next.t("email.subject");

  const name = data.firstName + " " + data.lastName;
  const phone = data.phoneNumber;
  const email = data.email;
  const product = data.product;
  const amount = "$" + refund;

  let address = data.address;
  var attention = "";
  var address2 = "";
  if (data.attentionTo) {
    attention = data.attentionTo;
  } else {
    attention = data.firstName + " " + data.lastName;
  }
  if (data.country === "US") {
    address2 = data.city + "," + data.state + " " + data.postalCode;
  } else {
    address2 = data.city + "," + data.province + " " + data.postalCode;
  }

  if (data.address2) {
    address = address + "," + data.address2;
  }
  let recipients = [email];
  let BccRecipients = ["acmeunitedotc@realtimeresults.net"];
  var emailToSend = {
    EmailFrom: "recallrtr@realtimeresults.net",
    Subject: tSubject,
    IsHtml: true,
    DisplayName: "no-reply@realtimeresults.net",
    Recipients: recipients,
    BccRecipients: BccRecipients,
    Body: `<h2 style='color: black; font-weight: bold;text-align:center;'>${i18next.t(
      "email.header"
    )}</h2><br /><h3 style='color: black;text-align:center;'>${i18next.t(
      "email.header1"
    )}</h3><br /><h3 style='color: black;text-align:center;'>${i18next.t(
      "email.id"
    )} ${instance}</h3>
      <table><tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.name"
      )}</p></td><td></td><td><p style='color: black;'>${name}</p></td></tr>
    <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
      "email.address"
    )}</p></td><td></td><td><p style='color: black;'>${address}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'></p></td><td></td><td><p style='color: black;'>${address2}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.email"
      )}</p></td><td></td><td><p style='color: black;'>${email}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.phone"
      )}</p></td><td></td><td><p style='color: black;'>${phone}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.shipTo"
      )}</p></td><td></td><td><p style='color: black;'>${attention}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.quantity"
      )}</p></td><td></td><td><p style='color: black;'>${product}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.refund"
      )}</p></td><td></td><td><p style='color: black;'>${amount}</p></td></tr></table>
      <p style='color: black;'>${i18next.t(
        "email.textA"
      )}</p><p style='color: black;'>${i18next.t(
      "email.textB"
    )}</p><p style='color: grey;'>${i18next.t("email.footer")}</p>`,
  };
  let url = getEnv();
  axios({
    method: "post",
    url: url + "/api/StaticData/SendEmail",
    data: emailToSend,
  })
    .then((response) => {
      console.log("success");
      return true;
    })
    .catch((response) => {
      console.log("fail");
      return false;
    });
}
function addressValidation(data) {
  let url = getEnv();
  var person = {
    Name: data.firstName + " " + data.lastName,
    Address: data.address,
    Address2: data.address2,
    City: data.city,
    State: data.state,
    Country: "US",
    PostalCode: data.postalCode,
  };
  axios({
    method: "post",
    url: url + "/Verification/Address",
    data: person,
  })
    .then((response) => {
      console.log("success");
      let responseNumber = Object.keys(response).length;
      var returnResponse = {
        Message: response[0].responseMessage,
        Valid: true,
      };
      if (responseNumber > 1) {
        returnResponse.Valid = false;
        return returnResponse;
      }
      if (returnResponse.Message === "Invalid UPS Shipping Address.") {
        returnResponse.Message =
          "Mailing address is not recognized.  Please verify the information in all fields and correct where needed. If you want to submit the registration with the address as listed, check the box below.";
        returnResponse.Valid = false;
        return returnResponse;
      }
      returnResponse.Address = response[0].address;
      returnResponse.Address = response[0].city;
      returnResponse.Address = response[0].state;
      returnResponse.Address = response[0].postalCode;
    })
    .catch((response) => {
      var returnResponse = {
        Message: response[0].responseMessage,
        Valid: false,
      };
      return returnResponse;
    });
}
function shippingLabel(data, instance, definitionID) {
  let url = getEnv();
  var person = {
    Name: data.firstName + " " + data.lastName,
    Address: data.address,
    Address2: data.address2,
    City: data.city,
    State: data.state,
    Country: "US",
    PostalCode: data.postalCode,
  };
  axios({
    method: "post",
    url: url + "Shipping/" + definitionID + "/upsLabel/" + instance,
    data: person,
  })
    .then((response) => {
      console.log("success");
      return true;
    })
    .catch((response) => {
      return false;
    });
}
